var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.373,
    height: 21.199,
    viewBox: "0 0 18.373 21.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(-3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M11.957,12.375a.707.707,0,0,1,.707.707v8.48a.707.707,0,1,1-1.413,0v-8.48A.707.707,0,0,1,11.957,12.375Zm3.533,0a.707.707,0,0,1,.707.707v8.48a.707.707,0,1,1-1.413,0v-8.48A.707.707,0,0,1,15.49,12.375Zm4.24.707a.707.707,0,1,0-1.413,0v8.48a.707.707,0,1,0,1.413,0Z",
    transform: "translate(-2.928 -4.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M21.748,4.24a1.413,1.413,0,0,1-1.413,1.413h-.707v12.72A2.827,2.827,0,0,1,16.8,21.2H8.322a2.827,2.827,0,0,1-2.827-2.827V5.653H4.788A1.413,1.413,0,0,1,3.375,4.24V2.827A1.413,1.413,0,0,1,4.788,1.413H9.735A1.413,1.413,0,0,1,11.148,0h2.827a1.413,1.413,0,0,1,1.413,1.413h4.947a1.413,1.413,0,0,1,1.413,1.413ZM7.075,5.653l-.167.084V18.373a1.413,1.413,0,0,0,1.413,1.413H16.8a1.413,1.413,0,0,0,1.413-1.413V5.737l-.166-.084ZM4.788,4.24V2.827H20.335V4.24Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e4101bc5e5b61db776fc0e188a0a47bd.svg";
export { ForwardRef as ReactComponent };